<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <h1>{{ pageTitle }}</h1>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-lg-6">
            <form [formGroup]="form">
              <div class="row mb-4 justify-content-between">
                <div class="col-12 col-md-auto">
                  {{ 'required_fields_label' | translate }}
                </div>
                @if (hasExistingConfig) {
                  <div class="col-12 col-md-auto">
                    <button class="btn btn-link delete-button" (click)="removeSso()">
                      <span class="me-2">{{ 'remove_sso' | translate }}</span>
                      <svg viewBox="0 0 8 8" class="delete-icon">
                        <use xlink:href="#trash-solid"></use>
                      </svg>
                    </button>
                  </div>
                }
              </div>
              <div class="row mb-4">
                <div class="col-12">
                  <app-common-input
                    [form]="form"
                    [formValidationRequest$]="formValidationRequest$"
                    [context]="{ label: 'idp_client_id', field: $sso.idpClientId }"
                  ></app-common-input>
                  <app-form-field-char-count [field]="form.get($sso.idpClientId)" [charLimit]="CHAR_LIMITS[$sso.idpClientId]">
                  </app-form-field-char-count>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-12">
                  <app-common-input
                    [form]="form"
                    [formValidationRequest$]="formValidationRequest$"
                    [context]="{ label: 'idp_domain', field: $sso.idpDomain }"
                  ></app-common-input>
                  <app-form-field-char-count [field]="form.get($sso.idpDomain)" [charLimit]="CHAR_LIMITS[$sso.idpDomain]">
                  </app-form-field-char-count>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-12">
                  <app-common-input
                    [form]="form"
                    [formValidationRequest$]="formValidationRequest$"
                    [context]="{ label: 'audience', field: $sso.audience }"
                  ></app-common-input>
                  <app-form-field-char-count [field]="form.get($sso.audience)" [charLimit]="CHAR_LIMITS[$sso.audience]">
                  </app-form-field-char-count>
                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto">
                  <a class="btn btn-link text-underline" [routerLink]="[tenantRoutePath]" data-test-id="tenant-sso-config-cancel">
                    {{ 'form_cancel' | translate }}
                  </a>
                </div>
                <div class="col-auto">
                  <button class="btn btn-lg btn-primary" type="submit" (click)="save()">
                    {{ 'action_save' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
